import {
  LIST_ACCOUNTS,
  SET_CURRENT_ACCOUNT,
  SET_WIRES_LIST,
  SET_WIRES_LIST_TOTAL,
  SET_PAYOUT_SETTINGS,
  SET_PAYMENT_METHODS,
  SET_WIRE_IMAGE,
  SET_ACC_EXT,
  SET_COUNTRIES,
  SET_STATUS_HISTORY,
  UPDATE_CURRENT_ACCOUNT,
} from "./types";

const initialState = {
  accounts: null,
  currentAccount: null,
  countries: null,
  statusHistory: null,
  statusHistoryCacheKey: null,
  extensions: null,
  wireImage: null,
  wiresList: null,
  wiresListTotal: 0,
  payoutSettings: null,
  paymentMethods: null,
};

const accountReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LIST_ACCOUNTS:
      return {
        ...state,
        accounts: payload,
      };
    case SET_CURRENT_ACCOUNT: {
      const accountChanged = payload?._id !== state.currentAccount?._id;
      return {
        ...state,
        currentAccount: payload,
        ...(accountChanged || !payload?._id
          ? { statusHistory: null, statusHistoryCacheKey: null }
          : {}),
      };
    }
    case UPDATE_CURRENT_ACCOUNT:
      return {
        ...state,
        currentAccount: {...state.currentAccount, ...payload},
      };
    case SET_COUNTRIES:
      return {
        ...state,
        countries: payload,
      };
    case SET_STATUS_HISTORY:
      return {
        ...state,
        statusHistory: payload.history,
        statusHistoryCacheKey: payload.cacheKey,
      };
    case SET_ACC_EXT:
      return {
        ...state,
        extensions: payload,
      };
    case SET_WIRE_IMAGE:
      return {
        ...state,
        wireImage: payload,
      };
    case SET_WIRES_LIST:
      return {
        ...state,
        wiresList: payload,
      };
    case SET_WIRES_LIST_TOTAL:
      return {
        ...state,
        wiresListTotal: payload,
      };
    case SET_PAYOUT_SETTINGS:
      return {
        ...state,
        payoutSettings: payload,
      };
    case SET_PAYMENT_METHODS:
      return {
        ...state,
        paymentMethods: payload,
      };
    default:
      return state;
  }
};

export default accountReducer;
